export default __webpack_public_path__ + "static/media/user_icon.1cd37fd6.jpg";